/* ==============================================================================================
 * BROWSER DETECTION UTIL
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @return {boolean}
	 */
	Sushi.Util.detectIe = function () {
		var ua = window.navigator.userAgent;

		return ua.indexOf("MSIE ") > 0 || ua.indexOf("Trident/") > 0 || ua.indexOf("Edge/") > 0;
	};

})(Sushi || (Sushi = {}));
